import { render, staticRenderFns } from "./CodeList.vue?vue&type=template&id=0a675ace&scoped=true"
import script from "./CodeList.vue?vue&type=script&lang=js"
export * from "./CodeList.vue?vue&type=script&lang=js"
import style0 from "./CodeList.vue?vue&type=style&index=0&id=0a675ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a675ace",
  null
  
)

export default component.exports